import EFPicture from '@elem/compCommon/EFPicture';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import EfSpec from '@elem/ui/ef-spec';

let sceneTextEnterE: any = null,
    sceneTextLeaveE: any = null;
export default function E() {
    const { useLang, useEffect, useState } = useGlobal();
    const { t } = useLang('delta_pro_ultra.launch.detail.SHP2');
    const [textEnter, setTextEnter] = useState(false);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const resizeAni = () => {
                if (sceneTextEnterE) {
                    AniContainer.removeScene(sceneTextEnterE);
                    sceneTextEnterE = null;
                }
                if (sceneTextLeaveE) {
                    AniContainer.removeScene(sceneTextLeaveE);
                    sceneTextLeaveE = null;
                }

                //const textTarget = document.querySelector('.shp2-detail-E .text-info') as HTMLElement;
                //if (textTarget) {
                const clientH = (window.innerHeight || 0) * 0.2;
                const startH = Math.min(clientH, 150);
                sceneTextEnterE = AniContainer.create({
                    triggerElement: '.shp2-detail-E .text-info',
                    triggerHook: 1,
                    offset: startH,
                    duration: 200,
                    onEnter: () => setTextEnter(true),
                    //onLeave: () => setTextEnter(false),
                });
                // sceneTextLeaveE = AniContainer.create({
                //     triggerElement: '.shp2-detail-E .text-info',
                //     triggerHook: 1,
                //     offset: -100,
                //     onEnter: () => setTextEnter(false),
                // });
                //}
            };
            resizeAni();
            // window.addEventListener('resize', resizeAni);
            return () => {
                if (sceneTextEnterE) {
                    AniContainer.removeScene(sceneTextEnterE);
                    sceneTextEnterE = null;
                }
                if (sceneTextLeaveE) {
                    AniContainer.removeScene(sceneTextLeaveE);
                    sceneTextLeaveE = null;
                }

                // window.removeEventListener('resize', resizeAni);
            };
        }
    }, []);

    return (
        <section id="shp2-detail-E" className={`shp2-detail-E shp2-detail-section ${css['shp2-detail-E']}`}>
            <EfSpec />
            <div className={`text-info ${textEnter ? 'enter' : ''}`}>
                <p className="subtitle">{t('secE_subtitle')}</p>
                <h2 className="title">{t('secE_title')}</h2>
                <p className="desc">
                    {t.rich('secE_desc', {
                        w: (text: string) => <span className="white">{text}</span>,
                    })}
                </p>
                <p className="tip">{t('secE_tip')}</p>
            </div>
            <div className="img-box">
                <EFPicture
                    src="https://websiteoss.ecoflow.com/upload/image/1742960076893/shp2E.jpg"
                    srcPad="https://websiteoss.ecoflow.com/upload/image/1742960076722/shp2E_M.jpg"
                    srcMobile="https://websiteoss.ecoflow.com/upload/image/1742960076722/shp2E_M.jpg"
                    // srcPad="/responsive/picture/smart-home-panel-2/launch/5_768.jpg"
                    // srcMobile="/responsive/picture/smart-home-panel-2/launch/5_768.jpg"
                    alt={t('secE_title')}
                />
            </div>
        </section>
    );
}
